// src/pages/SignupPage.tsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../lib/auth-api";
import { AuthLayout, Field } from "./LoginPage";

export function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<{ via_whitelist: boolean; message: string } | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    if (password !== confirm) {
      setError("パスワードが一致しません"); setBusy(false); return;
    }
    if (password.length < 8) {
      setError("パスワードは 8 文字以上で設定してください"); setBusy(false); return;
    }
    try {
      const r = await authApi.signup({ email, password });
      setDone({ via_whitelist: r.via_whitelist, message: r.message });
    } catch (err) {
      setError((err as Error).message);
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <AuthLayout title="確認メールを送信しました">
        <p className="text-sm text-slate-700 leading-relaxed">{done.message}</p>
        <p className="mt-3 text-xs text-slate-500">
          メールが届かない場合は、 迷惑メールフォルダもご確認ください。
        </p>
        <div className="mt-5 text-center text-sm">
          <Link to="/login" className="text-blue-700 hover:underline">ログイン画面に戻る</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="新規ユーザ登録">
      <form onSubmit={onSubmit} className="space-y-3">
        <Field label="メールアドレス (法人ドメイン推奨)">
          <input
            type="email" autoComplete="email" required value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input" placeholder="you@saitama-sekishinkai.org"
          />
        </Field>
        <Field label="パスワード (8 文字以上)">
          <input
            type="password" autoComplete="new-password" required minLength={8} value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="auth-input"
          />
        </Field>
        <Field label="パスワード (確認)">
          <input
            type="password" autoComplete="new-password" required minLength={8} value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="auth-input"
          />
        </Field>
        {error && <div className="auth-error">{error}</div>}
        <p className="text-xs text-slate-500">
          法人ドメイン (saitama-sekishinkai.org / sekishinkai.or.jp / saiwaihp.jp) で登録された場合は自動承認、
          それ以外は管理者承認後にログイン可能になります。
        </p>
        <button type="submit" disabled={busy} className="auth-button">
          {busy ? "送信中…" : "登録 + 確認メール送信"}
        </button>
      </form>
      <div className="mt-4 text-center text-sm">
        <Link to="/login" className="text-blue-700 hover:underline">ログイン画面に戻る</Link>
      </div>
    </AuthLayout>
  );
}
